import { Configuration } from '@azure/msal-browser';

declare var ConfigData: any;

export class MsalConfigApp {
  static loadConfig(): Configuration {
    // Verificar que ConfigData esté disponible
    if (typeof ConfigData === 'undefined' || !ConfigData) {
      console.error('ConfigData no está disponible al cargar MSAL config');
      throw new Error('ConfigData no disponible para MSAL');
    }

    return {
      auth: {
        clientId: ConfigData.ClientIdSSO || '',
        authority: ConfigData.AuthoritySSO || '',
        redirectUri: ConfigData.RedirectUriSSO || window.location.origin
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
      }
    };
  }
}
  